module.exports = __webpack_public_path__ + "static/img/new_fcsd.b12dc80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_fcsd.png
// module id = mLfr
// module chunks = 101